import styled from 'styled-components'
import ContentPanel from '../../_Containers/ContentPanel'

export const HalvesCard = styled(ContentPanel).attrs(p => ({...p, type: 'halves'}))``

export default HalvesCard